import { useEffect } from 'react';
import { ws, type WsMessage } from '@/lib/ws';

/**
 * useWebSocketEvent: subscribe komponen ke pesan WS dengan type tertentu.
 * Auto-cleanup saat komponen unmount (no leak).
 *
 * Contoh:
 *   useWebSocketEvent('gps', (msg) => {
 *     vehiclesStore.upsert(msg);
 *   });
 *
 *   useWebSocketEvent('alarm', (msg) => {
 *     toast.error(`Alarm: ${msg.alarm_name}`);
 *   });
 */
export function useWebSocketEvent<T extends WsMessage = WsMessage>(
  type: string,
  handler: (msg: T) => void,
) {
  useEffect(() => {
    return ws.on(type, handler as (m: WsMessage) => void);
    // handler ref change akan re-subscribe — caller wajib stable handler
    // (pakai useCallback kalau perlu) untuk hindari subscribe/unsubscribe rapat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    
  }, [type, handler]);
}
